export default __webpack_public_path__ + "static/media/2018_Miki_et_al_2018_EcologicalResearch.56ac1c67.pdf";